<h2>Capteurs en cours de transit</h2>

@if (isLoading) {
  <div>Chargement...</div>
}
@if (error) {
  <div>{{ error }}</div>
}
@if (!isLoading && !error) {
  <table>
    <thead>
      <tr>
        <th>Numéro de série</th>
        <th>Date d'emballage</th>
        <th>Suivi envoi</th>
        <th>Suivi bon retour capteur</th>
        <th>Suivi bon retour cartouches</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      @for (capteur of capteurs; track capteur.id) {
        <tr>
          <td>{{ capteur.numero_serie }}</td>
          <td>{{ capteur.date_emballage ? (capteur.date_emballage | date:'dd/MM/yyyy') : '' }}</td>
          <td>
            @if (isSuiviLoading(capteur.id, 'reference_envoi')) {
              <span>Chargement...</span>
            } @else if (getSuiviError(capteur.id, 'reference_envoi')) {
              <span class="error">{{ getSuiviError(capteur.id, 'reference_envoi') }}</span>
            } @else {
              <span>{{ getSuiviMessage(capteur.id, 'reference_envoi') }}</span>
            }
          </td>
          <td>
            @if (isSuiviLoading(capteur.id, 'code_bon_retour')) {
              <span>Chargement...</span>
            } @else if (getSuiviError(capteur.id, 'code_bon_retour')) {
              <span class="error">{{ getSuiviError(capteur.id, 'code_bon_retour') }}</span>
            } @else {
              <span>{{ getSuiviMessage(capteur.id, 'code_bon_retour') }}</span>
            }
          </td>
          <td>
            @if (isSuiviLoading(capteur.id, 'code_bon_retour_cartouches')) {
              <span>Chargement...</span>
            } @else if (getSuiviError(capteur.id, 'code_bon_retour_cartouches')) {
              <span class="error">{{ getSuiviError(capteur.id, 'code_bon_retour_cartouches') }}</span>
            } @else {
              <span>{{ getSuiviMessage(capteur.id, 'code_bon_retour_cartouches') }}</span>
            }
          </td>
          <td>
            <button
              type="button"
              [disabled]="isSuiviLoading(capteur.id, 'reference_envoi') || isSuiviLoading(capteur.id, 'code_bon_retour') || isSuiviLoading(capteur.id, 'code_bon_retour_cartouches')"
              (click)="fetchSuiviMessages(capteur)"
            >
              Voir les 3 suivis
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
}
